'use client'

import { getFullLocalizedUri, getI18n, I18nDictionary, LangCode } from '@/components/i18n/lang-context'
import { Page, PageContent, PageDescription, PageHeader, PageTitle } from '@/components/ui/page'
import { siteConfig } from '@/config/site.config'
import { contentI18nEn } from './content-i18n-en'
import { contentI18nFr } from './content-i18n-fr'


const I18N: I18nDictionary = {
  title: { en: 'Privacy Policy', fr: 'Politique de confidentialité' },
  applicability: { en: 'Effective from 11/07/2024', fr: 'En vigueur au 07/11/2024' },
  privacyPolicy: {
    en: 'Privacy Policy',
    fr: 'Politique de confidentialité'
  }
}

const contentI18n = {
  en: contentI18nEn,
  fr: contentI18nFr
}

export default function LBPrivacyPolicyPage({langCode}: {langCode: LangCode}) {

  const i18n = getI18n(I18N, langCode)

  const getI18nContent = () => contentI18n[langCode]
  const siteLink = getFullLocalizedUri('/', langCode)

  const descriptionElement = langCode === 'en' ?
    <>
      <a href={siteLink}>{siteLink}</a> developped by <a href={siteConfig.links.jarvix} target="_blank" rel="noopener noreferrer">Jarvix</a>.
    </> :
    <>
      <a href={siteLink}>{siteLink}</a> développé par <a href={siteConfig.links.jarvix} target="_blank" rel="noopener noreferrer">Jarvix</a>.
    </>

  return (
    <Page>
      <div className="base-text">
        <div className="body">
          <div className="header">
            <PageHeader>
              <PageTitle>{i18n.title}</PageTitle>
              <PageDescription>{i18n.applicability}</PageDescription>
              <PageDescription>{descriptionElement}</PageDescription>
            </PageHeader>
          </div>
          <PageContent>
            {getI18nContent()}
          </PageContent>
        </div>
      </div>
    </Page>
  )
}
